import {mapOverlayPanes} from "base/component/geo";
import {createLayerLegend, useLayerObject} from "base/map";

const markerBaseOptions = {
    marker: "s",
    fillColor: "#f0ecea",
    radius: 10,
    color: "#a57b6b",
    addStroke: true,
    weight: 1,
    opacity: 1,
    fillOpacity: 1,
    pane: mapOverlayPanes[1],
    interactive: false,
};

export const LayerLegend = createLayerLegend({
    layerName: "World",
    menuIconShape: markerBaseOptions.marker,
    defaultMarkerOptions: markerBaseOptions,
});

// eslint-disable-next-line no-unused-vars
export function useWorldLayer(onSelectElement) {
    return useLayerObject({
        legend: LayerLegend,
        detail: false,
    });
}
